import React, { useState } from 'react';
import './Recetas.css';

function Recetas() {
  const [showRecipe1, setShowRecipe1] = useState(false);
  const [showRecipe2, setShowRecipe2] = useState(false);
  const [showRecipe3, setShowRecipe3] = useState(false);

  const toggleRecipe = (recipeNumber) => {
    switch (recipeNumber) {
      case 1:
        setShowRecipe1(!showRecipe1);
        break;
      case 2:
        setShowRecipe2(!showRecipe2);
        break;
      case 3:
        setShowRecipe3(!showRecipe3);
        break;
      default:
        break;
    }
  };

  return (
    <section className="recetas">
      <h2>Delicias con Sabor a Vainilla</h2>
      <p className="recetas-intro">Descubre exquisitas recetas que resaltan el delicioso y aromático sabor de nuestra vainilla de Costa Rica.</p>

      <div className="recipe-grid">
        <div className="recipe-item">
          <img src="/salmon_vainilla.jpg" alt="Salmón con Salsa de Vainilla" />
          <h3>Salmón con Salsa de Vainilla</h3>
          <p>Una combinación sofisticada y sorprendente donde la dulzura sutil de la vainilla realza el sabor del salmón fresco.</p>
          <button className="recipe-button" onClick={() => toggleRecipe(1)}>
            {showRecipe1 ? 'Ocultar Receta' : 'Ver Receta'}
          </button>
          <div className={`recipe-details ${showRecipe1 ? 'show' : ''}`}>
            <h4>Ingredientes:</h4>
            <ul>
              <li>2 filetes de salmón fresco (aprox. 150g cada uno)</li>
              <li>Sal y pimienta al gusto</li>
              <li>1 cucharada de aceite de oliva</li>
              <li>Para la salsa de vainilla:</li>
              <li>1 cucharada de mantequilla sin sal</li>
              <li>1 chalota picada finamente</li>
              <li>1/2 taza de vino blanco seco</li>
              <li>1/2 taza de crema de leche fresca</li>
              <li>1 vaina de vainilla Sol de Vainilla, abierta y raspada (o 1 cucharadita de extracto de vainilla Sol de Vainilla)</li>
              <li>Jugo de medio limón</li>
              <li>Sal y pimienta blanca al gusto</li>
              <li>Unas ramitas de eneldo fresco para decorar (opcional)</li>
            </ul>
            <h4>Instrucciones:</h4>
            <ol>
              <li>Sazona los filetes de salmón con sal y pimienta.</li>
              <li>Calienta el aceite de oliva en una sartén a fuego medio-alto. Cocina el salmón durante 3-4 minutos por cada lado, o hasta que esté dorado y cocido por dentro. Retira el salmón de la sartén y reserva.</li>
              <li>Para la salsa: En la misma sartén, derrite la mantequilla a fuego medio. Sofríe la chalota picada hasta que esté transparente.</li>
              <li>Vierte el vino blanco y deja que se reduzca a la mitad, raspando el fondo de la sartén.</li>
              <li>Agrega la crema de leche y las semillas de la vaina de vainilla (o el extracto). Cocina a fuego lento durante unos minutos hasta que la salsa espese ligeramente.</li>
              <li>Retira del fuego y añade el jugo de limón. Sazona con sal y pimienta blanca al gusto.</li>
              <li>Para servir, coloca los filetes de salmón en platos individuales y vierte la salsa de vainilla por encima. Decora con eneldo fresco si lo deseas.</li>
            </ol>
          </div>
        </div>

        <div className="recipe-item">
          <img src="/helado_vainilla.jpg" alt="Helado de Vainilla" />
          <h3>Helado de Vainilla Clásico</h3>
          <p>Un postre atemporal que destaca la pureza y el aroma inconfundible de la vainilla natural.</p>
          <button className="recipe-button" onClick={() => toggleRecipe(2)}>
            {showRecipe2 ? 'Ocultar Receta' : 'Ver Receta'}
          </button>
          <div className={`recipe-details ${showRecipe2 ? 'show' : ''}`}>
            <h4>Ingredientes:</h4>
            <ul>
              <li>2 tazas de crema de leche fresca</li>
              <li>1 taza de leche entera</li>
              <li>3/4 taza de azúcar granulada</li>
              <li>1 vaina de vainilla Sol de Vainilla, abierta y raspada (o 2 cucharaditas de extracto de vainilla Sol de Vainilla)</li>
              <li>Una pizca de sal</li>
            </ul>
            <h4>Instrucciones:</h4>
            <ol>
              <li>En una cacerola mediana, combina la crema de leche, la leche entera, el azúcar y la sal.</li>
              <li>Abre la vaina de vainilla a lo largo y raspa las semillas en la mezcla de crema. También puedes añadir la vaina vacía para un sabor más intenso (retírala antes de enfriar). Si usas extracto, agrégalo al final.</li>
              <li>Calienta la mezcla a fuego medio, revolviendo ocasionalmente hasta que el azúcar se disuelva. No dejes que hierva.</li>
              <li>Retira del fuego (y retira la vaina si la usaste). Si usas extracto, incorpóralo ahora.</li>
              <li>Vierte la mezcla en un recipiente hermético y enfría en el refrigerador durante al menos 4 horas, o preferiblemente toda la noche.</li>
              <li>Vierte la mezcla fría en tu máquina para hacer helados y sigue las instrucciones del fabricante.</li>
              <li>Una vez que el helado tenga la consistencia deseada, transfiérelo a un recipiente y congela durante al menos 2 horas antes de servir.</li>
            </ol>
          </div>
        </div>

        <div className="recipe-item">
          <img src="/arroz_leche_vainilla.jpg" alt="Arroz con Leche con Vainilla" />
          <h3>Arroz con Leche con Vainilla</h3>
          <p>Un postre tradicional reconfortante, elevado con el toque dulce y fragante de la vainilla.</p>
          <button className="recipe-button" onClick={() => toggleRecipe(3)}>
            {showRecipe3 ? 'Ocultar Receta' : 'Ver Receta'}
          </button>
          <div className={`recipe-details ${showRecipe3 ? 'show' : ''}`}>
            <h4>Ingredientes:</h4>
            <ul>
              <li>1 taza de arroz blanco de grano corto</li>
              <li>4 tazas de leche entera</li>
              <li>1 taza de agua</li>
              <li>1/2 taza de azúcar granulada (ajustar al gusto)</li>
              <li>1 vaina de vainilla Sol de Vainilla, abierta y raspada (o 1 cucharadita de extracto de vainilla Sol de Vainilla)</li>
              <li>1 rama de canela</li>
              <li>Piel de 1 limón (solo la parte amarilla, sin lo blanco)</li>
              <li>Canela en polvo para espolvorear (opcional)</li>
            </ul>
            <h4>Instrucciones:</h4>
            <ol>
              <li>En una olla mediana, combina el arroz, el agua y la rama de canela. Lleva a ebullición, luego reduce el fuego a bajo, tapa y cocina durante 15-20 minutos, o hasta que el agua se haya absorbido.</li>
              <li>Agrega la leche, el azúcar, la piel de limón y las semillas de la vaina de vainilla (o el extracto). Si usaste la vaina, también puedes añadirla a la olla.</li>
              <li>Cocina a fuego bajo, revolviendo ocasionalmente para evitar que se pegue, durante unos 30-40 minutos, o hasta que el arroz esté tierno y el líquido se haya espesado a la consistencia deseada.</li>
              <li>Retira la rama de canela y la piel de limón (y la vaina de vainilla si la usaste). Prueba y ajusta el dulzor si es necesario.</li>
              <li>Sirve el arroz con leche caliente o frío. Espolvorea con canela en polvo si lo deseas.</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Recetas;